import {view} from '@sail/ui';

import {ChatBubbleDotCom} from './ChatBubbleDotCom';
import {ChatRow} from './ChatRow';
import {TextBody} from './TextBody';
import {TextBubbleDotCom} from './TextBubbleDotCom';

export type Props = {
  body: string;
  position?: 'start' | 'end';
  style?: 'bubble' | 'info' | 'none';
  background?: 'neutral100' | 'neutral600';
  error?: React.ReactNode;
  children?: React.ReactNode;
  messageId?: string;
  isOwnMessage?: boolean;
  streaming?: boolean;
};

export const TextRow = ({
  body,
  style = 'bubble',
  position,
  background = 'neutral100',
  error,
  children,
  messageId,
  isOwnMessage,
  streaming = true,
}: Props) => {
  let component;

  switch (style) {
    case 'bubble': {
      if (!isOwnMessage && streaming) {
        component = (
          <TextBubbleDotCom
            messageId={messageId}
            body={body}
            background={background}
          >
            {children}
          </TextBubbleDotCom>
        );

        // Preserve stream completion without adding an empty row above buttons.
        if (body.trim() === '' && !children && !error) {
          return component;
        }
        break;
      }

      component = (
        <ChatBubbleDotCom background={background} animation="disabled">
          {body ? <TextBody body={body} background={background} /> : null}
          {children}
        </ChatBubbleDotCom>
      );
      break;
    }
    case 'info':
      component = (
        <view.span>
          <TextBody body={body} background={background} textSize="small" />
          {children}
        </view.span>
      );
      break;
    case 'none':
    default:
      component = (
        <>
          <TextBody body={body} background={background} />
          {children}
        </>
      );
  }

  return (
    <view.div data-testid="text-row">
      <ChatRow position={position} error={error}>
        {component}
      </ChatRow>
    </view.div>
  );
};
